import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconUploadSvg } from "./IconUploadSvg.mjs";
const IconUpload = (props) => /* @__PURE__ */ jsx(
  IconContainer,
  {
    ...props,
    verticalCorrection: {
      uppercase: "none",
      lowercase: "up"
    },
    children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconUploadSvg, ...svgProps })
  }
);
export {
  IconUpload
};
